import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Loading extends PureComponent {
  render() {
    const { className, primary, brand, transparent, ...others } = this.props;
    const cls = classNames({
      "weui-loading": !primary && !brand && !transparent,
      "weui-primary-loading": primary || brand || transparent,
      "weui-primary-loading_brand": brand,
      "weui-primary-loading_transparent": transparent
    }, className);

    return (!primary && !brand && !transparent)
      ? <i role="img" aria-label="加载中" className={ cls } { ...others }></i>
      : <span role="img" aria-label="加载中" className={ cls } { ...others }>
        <span className="weui-primary-loading__dot"></span>
      </span>;
  }
}
